import * as React from 'react'

import { useSidebar } from '@/components/sui/sidebar'
import { useContextStore } from '@/stores/context'
import { useSandboxStore } from '@/stores/sandbox'

import { SandboxBanner } from '../sandbox-banner'
import { trackSandboxBannerViewed } from '../sandbox-banner/sandbox-banner.tracking'

export function SandboxBannerWrapper() {
  const [sandboxBannerVisible, setSandboxBannerVisible] = React.useState(false)
  const hasTrackedView = React.useRef(false)
  const { state, isMobile } = useSidebar()
  const isExpanded = isMobile || state === 'expanded'
  const isSandboxMode = useSandboxStore((s) => s.isSandboxMode)

  const userRole = useContextStore((s) =>
    s.userAccountContext?.userAccountInformation.role === 'Administrator'
      ? 'Administrator'
      : 'User',
  )

  const currentPlan = useContextStore(
    (s) => s.userAccountContext?.balanceInformation.featureType ?? 'Free',
  )

  const isManaged = useContextStore(
    (s) => s.userAccountContext?.accountInformation.isManaged ?? false,
  )

  React.useEffect(() => {
    if (isExpanded && isSandboxMode) {
      const timer = setTimeout(() => {
        setSandboxBannerVisible(true)
        if (!hasTrackedView.current) {
          trackSandboxBannerViewed({
            source: 'sidebar',
            userRole,
            currentPlan,
            isManaged,
          })
          hasTrackedView.current = true
        }
      }, 300)
      return () => clearTimeout(timer)
    } else {
      setSandboxBannerVisible(false)
    }
  }, [isExpanded, isSandboxMode, userRole, currentPlan, isManaged])

  if (!isSandboxMode) return null

  return (
    <>
      {/* Expanded version */}
      <div className="px-1 group-data-[collapsible=icon]:hidden">
        <div
          className={`transition-all duration-300 ${
            sandboxBannerVisible
              ? 'translate-y-0 opacity-100'
              : 'translate-y-2 opacity-0'
          }`}
        >
          <SandboxBanner source="sidebar" />
        </div>
      </div>
      {/* Collapsed version (icon only) */}
      <div className="hidden group-data-[collapsible=icon]:block">
        <SandboxBanner collapsed source="sidebar" />
      </div>
    </>
  )
}
